import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useMutation, useQuery } from '@apollo/client';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import defaultOperations from '@magento/peregrine/lib/talons/Wishlist/AddToListButton/addToListButton.gql';
import { Check, AlertCircle } from 'react-feather';
import Icon from '@magento/venia-ui/lib/components/Icon';
import { isEqual } from 'lodash';
import { REMOVE_PRODUCTS_FROM_WISHLIST } from '@magento/peregrine/lib/talons/WishlistPage/wishlistItem.gql';
import { useToasts } from '@magento/peregrine';
var CheckIcon = React.createElement(Icon, {
  size: 20,
  alt: "Success icon",
  src: Check
});
var ErrorIcon = React.createElement(Icon, {
  size: 20,
  alt: "Error icon",
  src: AlertCircle
});
export var useSingleWishlist = function useSingleWishlist(props) {
  var _wishlists$items_v, _wishlists$find;

  var afterAdd = props.afterAdd,
      beforeAdd = props.beforeAdd,
      item = props.item,
      setModalData = props.setModalData,
      setActiveItem = props.setActiveItem,
      isFavorite = props.isFavorite,
      setIsModalOpen = props.setIsModalOpen,
      _props$isPdp = props.isPdp,
      isPdp = _props$isPdp === void 0 ? false : _props$isPdp,
      _props$isWishlist = props.isWishlist,
      isWishlist = _props$isWishlist === void 0 ? false : _props$isWishlist,
      wishlists = props.wishlists,
      _props$refetchFavorit = props.refetchFavorites,
      refetchFavorites = _props$refetchFavorit === void 0 ? function () {} : _props$refetchFavorit;

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 2),
      addToast = _useToasts2[1].addToast;

  var toast = function toast(text) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    return addToast({
      type: type,
      icon: type === 'success' ? CheckIcon : ErrorIcon,
      message: formatMessage({
        id: text,
        defaultMessage: text
      }),
      timeout: 5000
    });
  };

  var _useMutation = useMutation(REMOVE_PRODUCTS_FROM_WISHLIST),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      removeProductFromWishlistMutation = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      loadingRemoveFromWishlist = _useMutation2$.loading,
      errorRemoveFromWishlist = _useMutation2$.error;

  var removeProductFromWishlist = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
      var message, input;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              message = props.message, input = props.input;
              _context.prev = 1;
              _context.next = 4;
              return removeProductFromWishlistMutation({
                variables: input
              });

            case 4:
              // refetchWishlist();
              if (message) toast(message);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              toast(_context.t0.message, 'error');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function removeProductFromWishlist(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var items = wishlists === null || wishlists === void 0 ? void 0 : (_wishlists$items_v = wishlists.items_v2) === null || _wishlists$items_v === void 0 ? void 0 : _wishlists$items_v.items;
  var myFavorites = (_wishlists$find = wishlists === null || wishlists === void 0 ? void 0 : wishlists.find(function (wItem) {
    return ['Wish List', 'Favorites', 'My Favorites'].includes(wItem.name);
  })) !== null && _wishlists$find !== void 0 ? _wishlists$find : wishlists === null || wishlists === void 0 ? void 0 : wishlists[0];

  var condition = function condition(wishlistItem, item) {
    var _wishlistItem$product2, _wishlistItem$configu, _item$selected_option;

    if (!(wishlistItem !== null && wishlistItem !== void 0 && wishlistItem.configurable_options)) {
      var _wishlistItem$product;

      // For the non-configurable items - outlet items
      return (wishlistItem === null || wishlistItem === void 0 ? void 0 : (_wishlistItem$product = wishlistItem.product) === null || _wishlistItem$product === void 0 ? void 0 : _wishlistItem$product.sku) === (item === null || item === void 0 ? void 0 : item.sku);
    }

    return (wishlistItem === null || wishlistItem === void 0 ? void 0 : (_wishlistItem$product2 = wishlistItem.product) === null || _wishlistItem$product2 === void 0 ? void 0 : _wishlistItem$product2.sku) === (item === null || item === void 0 ? void 0 : item.sku) && !(wishlistItem !== null && wishlistItem !== void 0 && wishlistItem.configurable_options) ? true : isEqual(_toConsumableArray(wishlistItem === null || wishlistItem === void 0 ? void 0 : (_wishlistItem$configu = wishlistItem.configurable_options) === null || _wishlistItem$configu === void 0 ? void 0 : _wishlistItem$configu.reduce(function (acc, curr) {
      return [].concat(_toConsumableArray(acc), [curr === null || curr === void 0 ? void 0 : curr.configurable_product_option_value_uid]);
    }, [])), item !== null && item !== void 0 && (_item$selected_option = item.selected_options) !== null && _item$selected_option !== void 0 && _item$selected_option.length ? item.selected_options : isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite.configurable_options);
  };

  var itemInProjects = useMemo(function () {
    return wishlists ? _toConsumableArray(wishlists === null || wishlists === void 0 ? void 0 : wishlists.filter(function (wishlist) {
      var _wishlist$items_v, _wishlist$items_v$ite;

      return (_wishlist$items_v = wishlist.items_v2) === null || _wishlist$items_v === void 0 ? void 0 : (_wishlist$items_v$ite = _wishlist$items_v.items) === null || _wishlist$items_v$ite === void 0 ? void 0 : _wishlist$items_v$ite.some(function (wishlistItem) {
        return condition(wishlistItem, item);
      });
    })) : [];
  }, [wishlists]);
  var operations = mergeOperations(defaultOperations, props.operations);

  var _useMutation3 = useMutation(operations.addProductToWishlistMutation),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      addProductToWishlist = _useMutation4[0],
      _useMutation4$ = _useMutation4[1],
      addProductData = _useMutation4$.data,
      errorAddingProduct = _useMutation4$.error,
      isAddingToWishlist = _useMutation4$.loading;

  var _useQuery = useQuery(operations.getProductsInWishlistsQuery),
      client = _useQuery.client,
      customerWishlistProducts = _useQuery.data.customerWishlistProducts;

  var isSelected = useMemo(function () {
    return customerWishlistProducts.includes(item.sku) || isAddingToWishlist;
  }, [customerWishlistProducts, isAddingToWishlist, item === null || item === void 0 ? void 0 : item.sku, isFavorite]);

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isSignedIn = _useUserContext2[0].isSignedIn;

  var removeFromFavorites = function removeFromFavorites(input) {
    var _itemInProjects$, _item$selected_option2, _itemInProjects$2, _itemInProjects$2$ite, _itemInProjects$2$ite2, _itemInProjects$2$ite3, _itemInProjects$3, _itemInProjects$3$ite, _itemInProjects$3$ite2, _itemInProjects$3$ite3, _itemInProjects$4, _itemInProjects$4$ite, _itemInProjects$4$ite2, _itemInProjects$4$ite3;

    removeProductFromWishlist({
      message: "Item has been successfully removed from My Favorites",
      input: {
        wishlistId: Number(itemInProjects === null || itemInProjects === void 0 ? void 0 : (_itemInProjects$ = itemInProjects[0]) === null || _itemInProjects$ === void 0 ? void 0 : _itemInProjects$.id),
        wishlistItemsId: [item !== null && item !== void 0 && (_item$selected_option2 = item.selected_options) !== null && _item$selected_option2 !== void 0 && _item$selected_option2.length ? itemInProjects === null || itemInProjects === void 0 ? void 0 : (_itemInProjects$2 = itemInProjects[0]) === null || _itemInProjects$2 === void 0 ? void 0 : (_itemInProjects$2$ite = _itemInProjects$2.items_v2) === null || _itemInProjects$2$ite === void 0 ? void 0 : (_itemInProjects$2$ite2 = _itemInProjects$2$ite.items) === null || _itemInProjects$2$ite2 === void 0 ? void 0 : (_itemInProjects$2$ite3 = _itemInProjects$2$ite2.find(function (data) {
          return condition(data, item);
        })) === null || _itemInProjects$2$ite3 === void 0 ? void 0 : _itemInProjects$2$ite3.id : isFavorite !== null && isFavorite !== void 0 && isFavorite.configurable_options ? itemInProjects === null || itemInProjects === void 0 ? void 0 : (_itemInProjects$3 = itemInProjects[0]) === null || _itemInProjects$3 === void 0 ? void 0 : (_itemInProjects$3$ite = _itemInProjects$3.items_v2) === null || _itemInProjects$3$ite === void 0 ? void 0 : (_itemInProjects$3$ite2 = _itemInProjects$3$ite.items) === null || _itemInProjects$3$ite2 === void 0 ? void 0 : (_itemInProjects$3$ite3 = _itemInProjects$3$ite2.find(function (data) {
          var _data$product, _data$configurable_op;

          return (data === null || data === void 0 ? void 0 : (_data$product = data.product) === null || _data$product === void 0 ? void 0 : _data$product.sku) === (item === null || item === void 0 ? void 0 : item.sku) && !(data !== null && data !== void 0 && (_data$configurable_op = data.configurable_options) !== null && _data$configurable_op !== void 0 && _data$configurable_op.length);
        })) === null || _itemInProjects$3$ite3 === void 0 ? void 0 : _itemInProjects$3$ite3.id : itemInProjects === null || itemInProjects === void 0 ? void 0 : (_itemInProjects$4 = itemInProjects[0]) === null || _itemInProjects$4 === void 0 ? void 0 : (_itemInProjects$4$ite = _itemInProjects$4.items_v2) === null || _itemInProjects$4$ite === void 0 ? void 0 : (_itemInProjects$4$ite2 = _itemInProjects$4$ite.items) === null || _itemInProjects$4$ite2 === void 0 ? void 0 : (_itemInProjects$4$ite3 = _itemInProjects$4$ite2.find(function (data) {
          var _data$product2;

          return (data === null || data === void 0 ? void 0 : (_data$product2 = data.product) === null || _data$product2 === void 0 ? void 0 : _data$product2.sku) === (item === null || item === void 0 ? void 0 : item.sku);
        })) === null || _itemInProjects$4$ite3 === void 0 ? void 0 : _itemInProjects$4$ite3.id]
      }
    }); // refetchWishlist();
    // refetch();
  };

  var handleClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _myFavorites$items_v, _myFavorites$items_v$, _myFavorites$items_v2, _myFavorites$items_v3, _myFavorites$items_v4, _wishlists$, _wishlists$$items_v, _wishlists$$items_v$i, _wishlists$$items_v$i2, isItemInWishlistWithoutConfig, wishlistItemsId;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setActiveItem(item);

            if (isSignedIn) {
              _context2.next = 5;
              break;
            }

            setModalData('SIGN_IN');
            _context2.next = 38;
            break;

          case 5:
            _context2.prev = 5;

            if (!(isWishlist || !isFavorite && window.location.pathname.includes('favorites'))) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", setIsModalOpen(true));

          case 8:
            isItemInWishlistWithoutConfig = myFavorites === null || myFavorites === void 0 ? void 0 : (_myFavorites$items_v = myFavorites.items_v2) === null || _myFavorites$items_v === void 0 ? void 0 : (_myFavorites$items_v$ = _myFavorites$items_v.items) === null || _myFavorites$items_v$ === void 0 ? void 0 : _myFavorites$items_v$.find(function (data) {
              var _data$product3, _data$configurable_op2;

              return (data === null || data === void 0 ? void 0 : (_data$product3 = data.product) === null || _data$product3 === void 0 ? void 0 : _data$product3.sku) === (item === null || item === void 0 ? void 0 : item.sku) && !(data !== null && data !== void 0 && (_data$configurable_op2 = data.configurable_options) !== null && _data$configurable_op2 !== void 0 && _data$configurable_op2.length);
            }); // item id in My Favorites wish list

            wishlistItemsId = [myFavorites === null || myFavorites === void 0 ? void 0 : (_myFavorites$items_v2 = myFavorites.items_v2) === null || _myFavorites$items_v2 === void 0 ? void 0 : (_myFavorites$items_v3 = _myFavorites$items_v2.items) === null || _myFavorites$items_v3 === void 0 ? void 0 : (_myFavorites$items_v4 = _myFavorites$items_v3.find(function (data) {
              var _data$product4;

              return (data === null || data === void 0 ? void 0 : (_data$product4 = data.product) === null || _data$product4 === void 0 ? void 0 : _data$product4.sku) === (item === null || item === void 0 ? void 0 : item.sku);
            })) === null || _myFavorites$items_v4 === void 0 ? void 0 : _myFavorites$items_v4.id] || [wishlists === null || wishlists === void 0 ? void 0 : (_wishlists$ = wishlists[0]) === null || _wishlists$ === void 0 ? void 0 : (_wishlists$$items_v = _wishlists$.items_v2) === null || _wishlists$$items_v === void 0 ? void 0 : (_wishlists$$items_v$i = _wishlists$$items_v.items) === null || _wishlists$$items_v$i === void 0 ? void 0 : (_wishlists$$items_v$i2 = _wishlists$$items_v$i.find(function (data) {
              var _data$product5;

              return (data === null || data === void 0 ? void 0 : (_data$product5 = data.product) === null || _data$product5 === void 0 ? void 0 : _data$product5.sku) === (item === null || item === void 0 ? void 0 : item.sku);
            })) === null || _wishlists$$items_v$i2 === void 0 ? void 0 : _wishlists$$items_v$i2.id];

            if (!(isFavorite && !isWishlist)) {
              _context2.next = 13;
              break;
            }

            // when we're on PDP,  open the dialog as long as the product is in the favorites
            setIsModalOpen(true);
            return _context2.abrupt("return");

          case 13:
            if (!(itemInProjects !== null && itemInProjects !== void 0 && itemInProjects.length && isFavorite)) {
              _context2.next = 21;
              break;
            }

            if (!((itemInProjects === null || itemInProjects === void 0 ? void 0 : itemInProjects.length) > 1)) {
              _context2.next = 19;
              break;
            }

            // If an item is in multiple wishlist, open wishlist dialog instead of removing the item
            setIsModalOpen(true);
            return _context2.abrupt("return");

          case 19:
            removeFromFavorites({
              wishlistId: Number(myFavorites === null || myFavorites === void 0 ? void 0 : myFavorites.id),
              wishlistItemsId: wishlistItemsId
            });
            return _context2.abrupt("return");

          case 21:
            if (!beforeAdd) {
              _context2.next = 24;
              break;
            }

            _context2.next = 24;
            return beforeAdd();

          case 24:
            if (!(isItemInWishlistWithoutConfig && isPdp)) {
              _context2.next = 27;
              break;
            }

            _context2.next = 27;
            return removeProductFromWishlist({
              message: "",
              input: {
                wishlistId: Number(myFavorites === null || myFavorites === void 0 ? void 0 : myFavorites.id),
                wishlistItemsId: [isItemInWishlistWithoutConfig === null || isItemInWishlistWithoutConfig === void 0 ? void 0 : isItemInWishlistWithoutConfig.id]
              }
            });

          case 27:
            _context2.next = 29;
            return addProductToWishlist({
              variables: {
                wishlistId: '0',
                itemOptions: item
              }
            });

          case 29:
            refetchFavorites();
            client.writeQuery({
              query: operations.getProductsInWishlistsQuery,
              data: {
                customerWishlistProducts: [].concat(_toConsumableArray(customerWishlistProducts), [item.sku])
              }
            });
            setModalData('MIDDLE_DIALOG');
            if (afterAdd) afterAdd();
            _context2.next = 38;
            break;

          case 35:
            _context2.prev = 35;
            _context2.t0 = _context2["catch"](5);
            console.error(_context2.t0);

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 35]]);
  })), [addProductToWishlist, afterAdd, beforeAdd, client, customerWishlistProducts, isSignedIn, item, items, operations.getProductsInWishlistsQuery, setActiveItem, isFavorite, itemInProjects, isWishlist]);
  var successToastProps = useMemo(function () {
    return null;
  }, [addProductData, formatMessage]);
  var errorToastProps = useMemo(function () {
    if (errorAddingProduct) {
      return {
        type: 'error',
        message: formatMessage({
          id: 'wishlist.galleryButton.addError',
          defaultMessage: 'Something went wrong adding the product to your wishlist.'
        }),
        timeout: 5000
      };
    }

    return null;
  }, [errorAddingProduct, formatMessage]);
  var buttonProps = useMemo(function () {
    return {
      'aria-label': formatMessage({
        id: 'wishlistButton.addText',
        defaultMessage: 'Add to Favorites'
      }),
      onPress: handleClick,
      type: 'button'
    };
  }, [formatMessage, handleClick]);
  return {
    buttonProps: buttonProps,
    buttonText: props.buttonText && props.buttonText(isSelected),
    customerWishlistProducts: customerWishlistProducts,
    errorToastProps: errorToastProps,
    handleClick: handleClick,
    isSelected: isSelected,
    successToastProps: successToastProps
  };
};